import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_DT_CAPACITY,
  GET_DT_CAPACITY_COLUMN,
  SAVE_DT_CAPACITY,
  SAVE_DT_CAPACITY_COLUMN,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}

// const columnColor = [
//   "rgb(126 142 218)",
//   "rgb(100 120 215)",
//   "rgb(85 110 230)",
//   "rgb(67 98 248)",
// ];
function Capacity(props) {
  const dispatch = useDispatch();
  const permission = getPermission();
  const [dateNow, setDateNow] = useState(moment(new Date()).format("YYYY-MM"));
  const [showManageColumn, setShowManageColumn] = useState(false);
  const [columnDataList, setColumnDataList] = useState([]);
  const [columnManageList, setColumnManageList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "year",
      text: "Date",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: colorOption[0].label,
        width: "2%",
      },
    },
  ]);

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const addHeaderTable = () => {
    let prevHeader = document.getElementById("pipeline-capacity");
    prevHeader && prevHeader.remove();
    let thead = document
      .getElementById("capacity-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th id="pipeline-capacity" colspan="' +
      (columnDataList.length + 1) +
      '" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Pipeline Capacity</th>';
    thead.prepend(tr);
  };
  const getColumn = () => post(GET_DT_CAPACITY_COLUMN, {});
  const handleAddColumn = () => {
    setColumnManageList(prevent => [
      ...prevent,
      {
        ROW: columnManageList.length + 1,
        PID: "",
        CAPACITYCOLUMN_ORDER: columnManageList.length + 1,
        CAPACITYCOLUMN_NAME: "",
        SCADATAG_NAME: "",
        QTYPOINT_NAME: "",
        GMDRTAG_NAME: "",
        CAPACITYCOLUMN_DESC: "",
        CAPACITYCOLUMN_TYPE: "",
        CAPACITYCOLUMN_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        color: colorOption[0],
        show: { label: "Show", value: 1 },
        source: { label: "Manual", value: 0 }
      },
    ]);
  };
  const handleSaveColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnManageList.map(function (item) {
        return item.CAPACITYCOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageList.some(
          row => row.CAPACITYCOLUMN_NAME == "" || row.CAPACITYCOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageList];
        let res = await post(SAVE_DT_CAPACITY_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageColumn(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const generateRow = () => {
    function getDaysInMonth(year) {
      let currentYear = new Date().getFullYear();
      let yearList = [];

      for (let index = year; index <= currentYear; index++) {
        yearList.push({
          year: index,
          CAPACITY_DATE: moment(new Date(index, 0, 1)).format("YYYY-MM-DD"),
          CAPACITY_YEAR: moment(new Date(index, 0, 1)).format("YYYY-MM-DD"),
        });
      }
      return yearList;
    }

    let dayList;
    let startYear = 2019;
    let tmp;
    for (var i = dataList.length - 1; i >= 0; i--) {
      tmp = moment(dataList[i].CAPACITY_YEAR).format("YYYY");
      if (tmp < startYear) startYear = tmp;
    }

    // if (dataList.length > 0) {
    dayList = getDaysInMonth(startYear);
    dayList = addFieldToModelDeviceList(dayList);

    setModelDeviceList(dayList);
    // }
  };

  const formatNumber = (cellContent, row) => {
    // console.log(cellContent);
    return (
      <div>
        {numberFormat(cellContent, 2)}
      </div>
    );
  };

  const renderColumn = () => {
    // console.log(columnDataList)
    setColumnRenderList([
      {
        dataField: "year",
        text: "Year",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: colorOption[0].label,
          width: "20px",
          fontSize: '10px'
        },
      },
      ...columnDataList
        .sort((a, b) =>
          a.CAPACITYCOLUMN_ORDER > b.CAPACITYCOLUMN_ORDER
            ? 1
            : b.CAPACITYCOLUMN_ORDER > a.CAPACITYCOLUMN_ORDER
              ? -1
              : 0
        )
        .filter(
          obj =>
            obj.CAPACITYCOLUMN_SHOW == true || obj.CAPACITYCOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.CAPACITYCOLUMN_NAME.replaceAll(".", "_"),
          text: obj.CAPACITYCOLUMN_NAME,
          headerAlign: "center",
          editable: true,
          align: "center",
          formatter: formatNumber,
          headerStyle: {
            backgroundColor: colorOption[obj.CAPACITYCOLUMN_TYPE].label,
            width: "20px",
            fontSize: '10px'
          },
          style: { 
            cursor: "pointer" 
          },
          editorStyle: () => {
            return { height: "25px" }
          },
          classes: (cell, row, rowIndex, colIndex) => {
            let className = ""
            if (obj.STATUS_FLAG != 0) className += 'from-source';
            if (obj.STATUS_FLAG == 1 || obj.STATUS_FLAG == 3) className += ' pmis';
            return className
          },
          validator: (newValue, row, column, done) => {
            setTimeout(() => {
              if (isNaN(newValue)) {
                return done({
                  valid: false,
                  message: "Should be numeric",
                });
              }
              return done();
            }, 0);
            return {
              async: true,
            };
          },
        })),
    ]);
  };

  const handleShowManageColumn = async () => {
    setColumnManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumn(true);
      let column = await getColumn();
      // console.log(column);
      setColumnManageList(
        column.data.dtKeyinCapacityColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          color: colorOption[obj.CAPACITYCOLUMN_TYPE],
          show: obj.CAPACITYCOLUMN_SHOW == 1 ? { label: "Show", value: 1 } : { label: "Hide", value: 0 },
          source: obj.STATUS_FLAG == 0 ? { label: "Manual", value: 0 } : obj.STATUS_FLAG == 1 ? { label: "Scada", value: 1 } : { label: "Flow Selection", value: 2 }
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };

  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];

      modelDeviceList.map(obj => {
        columnDataList.map(objColumn => {
          data.push({
            ...obj[
            `${objColumn.CAPACITYCOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            CAPACITY_DATA:
              obj[objColumn.CAPACITYCOLUMN_NAME.replaceAll(".", "_")],
          });
        });
      });
      //   console.log(data);
      let res = await post(SAVE_DT_CAPACITY, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const fetchData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let column = await getColumn();
      setColumnDataList(
        column.data.dtKeyinCapacityColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      let res = await post(GET_DT_CAPACITY, {});
      setDataList(res.data.dtKeyinCapacityList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  useEffect(() => {
    generateRow();
  }, [dataList]);
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    renderColumn();
    addHeaderTable();
    if (columnDataList.length > 1) {
      generateRow();
    }
  }, [columnDataList]);

  const addFieldToModelDeviceList = rowList => {
    let dataModel = {
      PID: "",
      CAPACITY_DATE: "",
      CAPACITYCOLUMN_PID: "",
      CAPACITYCOLUMN_ORDER: 0,
      CAPACITYCOLUMN_NAME: "",
      CAPACITY_YEAR: 0,
      CAPACITY_DATA: null,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      // console.log(dataList)
      let data = dataList;
      let modelList = [];
      columnDataList.map(objColumn => {
        // console.log(objColumn)
        modelList = [
          ...rowList.map(obj => {
            let value = data.find(
              value =>
                value.CAPACITYCOLUMN_PID == objColumn.PID &&
                moment(value.CAPACITY_YEAR).format("YYYY") ==
                moment(obj.CAPACITY_YEAR).format("YYYY")
            );
            obj[objColumn.CAPACITYCOLUMN_NAME.replaceAll(".", "_")] = value
              ? value.CAPACITY_DATA
              : "";
            obj[`${objColumn.CAPACITYCOLUMN_NAME.replaceAll(".", "_")}__data`] =
            {
              ...dataModel,
              ...value,
              CAPACITY_DATE: obj.CAPACITY_DATE,
              CAPACITY_YEAR: obj.CAPACITY_YEAR,
              CAPACITYCOLUMN_PID: objColumn.PID,
              CAPACITYCOLUMN_ORDER: objColumn.CAPACITYCOLUMN_ORDER,
              CAPACITYCOLUMN_NAME: objColumn.CAPACITYCOLUMN_NAME,
            };
            return { ...obj };
          }),
        ];
      });
      return modelList;
    }
  };
  const PickColor = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  CAPACITYCOLUMN_TYPE: selected.value
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }
  const SelectShow = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  CAPACITYCOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const columnManage = [
    {
      dataField: "CAPACITYCOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",

      style: {
        width: "50px",
        cursor:"pointer",
      },
      type: "number",
    },

    {
      dataField: "CAPACITYCOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "100px",
      },
    },
    // {
    //   dataField: "STATUS_FLAG",
    //   text: "Source",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   editor: {
    //     type: Type.SELECT,
    //     options: [
    //       {
    //         value: 0,
    //         label: "Manual",
    //       },
    //       {
    //         value: 1,
    //         label: "SCADA",
    //       },
    //       // {
    //       //   value: 2,
    //       //   label: "Flow Selection",
    //       // },
    //       {
    //         value: 3,
    //         label: "GMDR",
    //       },
    //     ],
    //   },
    //   formatter: (cell, row, rowIndex) =>
    //     row.STATUS_FLAG == 0
    //       ? "Manual"
    //       : row.STATUS_FLAG == 1
    //       ? "SCADA"
    //       : row.STATUS_FLAG == 2
    //       ? "Flow Selection"
    //       : "GMDR",

    // },
    // {
    //   dataField: "SCADATAG_NAME",
    //   text: "SCADA Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },

    // {
    //   dataField: "QTYPOINT_NAME",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GMDR Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    {
      dataField: "CAPACITYCOLUMN_DESC",
      text: "Description",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "150px",
        cursor:"pointer",
      },
    },
    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === 'asc') {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColor,
    },

    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === 'asc') {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShow
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];

  return (
    <div>
      <Col sm="12">
        <div className="d-flex justify-content-end">
          {permission.mMIM && (
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() => handleShowManageColumn()}
            >
              <i className="bx bx-columns"></i>&nbsp; Manage Column Pipeline
              Capacity
            </button>
          )}
          {permission.eOTH && (
            <button
              type="button"
              className="btn btn-success me-2"
              onClick={handleSaveData}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
          )}
        </div>
        <div className="mt-2">
          <div className="table-responsive">

            <BootstrapTable
              id="capacity-tab-table"
              keyField="year"
              // wrapperClasses="table-on-scroll"
              data={modelDeviceList}
              rowStyle={rowStyleFontWhite}
              columns={columnRenderList}
              headerClasses="header-style"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                onStartEdit: (oldValue, newValue, row, column) => {
                  $("#capacity-tab-table .form-control.editor.edit-text").bind(
                    "enterKey",
                    function (e) {
                      let cell = $(this).parent().next();
                      setTimeout(() => {
                        cell.click();
                      }, 50);
                    }
                  );
                  $(
                    "#capacity-tab-table .form-control.editor.edit-text"
                  ).keypress(function (e) {
                    if (e.keyCode == 13) {
                      $(this).trigger("enterKey");
                    }
                  });
                },
              })}
            />
          </div>
        </div>
      </Col >
      <Modal size="xl" isOpen={showManageColumn} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Pipeline Capacity</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">

          <BootstrapTable
            id="collumn-capacity-table"
            keyField="ROW"
            data={columnManageList}
            columns={columnManage}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(columnDataList);
              },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div >
  );
}
const defaultSortColumnManage = [
  {
    dataField: "CAPACITYCOLUMN_ORDER",
    order: "asc", // or desc
  },
];
export default Capacity;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

Capacity.propTypes = {
  // yearSelected: PropTypes.any,
};
